import { FilterItemType } from '@otp/ui';
import { TFunction } from 'i18next';

import { StoreModel, WttpTemplate } from 'src/graphql/generated/graphql';

export const getFilterConfig = ({
  t,
  stores,
  templates,
}: {
  t: TFunction;
  stores: Pick<StoreModel, 'nationalStoreNumber'>[];
  templates: Pick<WttpTemplate, 'name' | 'id'>[];
}) => [
  {
    id: 'storeNumbers',
    size: 3,
    type: FilterItemType.Multiselect,
    props: {
      multiple: true,
      limitTags: 6,
      inputProps: {
        placeholder: t('manage-restaurants.store-number'),
        variant: 'outlined',
        name: 'storeNumbers',
        label: t('manage-restaurants.store-number'),
      },
      options: stores.map((store) => {
        return {
          name: store.nationalStoreNumber,
          value: store.nationalStoreNumber,
        };
      }),
    },
  },
  {
    id: 'wttpTemplateId',
    size: 3,
    type: FilterItemType.Multiselect,
    props: {
      multiple: false,
      inputProps: {
        placeholder: t('wttp.template.store-assignment.existing-assignment'),
        variant: 'outlined',
        name: 'wttpTemplateId',
        label: t('wttp.template.store-assignment.existing-assignment'),
      },
      options: templates.map((template) => {
        return {
          name: template.name,
          value: template.id,
        };
      }),
    },
  },
];
